module.exports = global["angular"] = require("-!/home/circleci/repo/node_modules/exports-loader/index.js?window.angular!/home/circleci/repo/bower_components/angular/angular.js");


//////////////////
// WEBPACK FOOTER
// ./bower_components/angular/angular.js
// module id = 29
// module chunks = 0 1